import { render } from "./B2bTableMenuCentres.vue?vue&type=template&id=11731540&scoped=true&lang=pug"
import script from "./B2bTableMenuCentres.vue?vue&type=script&lang=js"
export * from "./B2bTableMenuCentres.vue?vue&type=script&lang=js"

import "./B2bTableMenuCentres.vue?vue&type=style&index=0&id=11731540&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11731540"]])

export default __exports__